/**
 * Created by Qingger Corp.
 * User: ll
 * Date: 2010/07/17
 * Time: 15:51
 */
import { Vue, Component, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';
import SelectProvince from '@/views/components/selectProvince';
import { noop } from '@/util';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({})
export default class EditPostage extends Vue {
  $refs: {
    form: ElForm;
  };

  // 是否只读
  public isDisabled = false;

  // 策略信息
  public postageInfo: PostageInfo = {
    transId: 0,
    transName: '',
    siteCodeList: [],
    transList: [],
  };

  // Id
  public transId = 0;

  // 权限检测
  public isContentBodyShow = false;

  // 验证规则
  public rules: ItemObject = {
    siteCodeList: [{ required: true, message: '请选择网点', trigger: 'change' }],
    transName: [{ required: true, message: '请输入策略名称', trigger: 'change' }],
  };

  // 所有区域列表
  public areaList: Array<AreaList> = [];

  // 获取已选地区ID
  get getAreaId() {
    let result = [];
    this.postageInfo.transList.forEach((postItem) => {
      result = result.concat(postItem.areaList);
    });
    return result;
  }

  /**
   * 周期函数
   */
  public created() {
    // @ts-expect-error
    this.transId = Math.trunc(this.$route.params.id) || 0;
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    this.transId ? this.getPostageInfo(loading) : this.getProvinceList(loading);
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-TRANSPORT-TEMPLATE');
  }

  // 方法

  /**
   * 获取详情
   */
  public getPostageInfo(loading) {
    IPSService.getPostageInfo({
      postParams: {
        transId: this.transId,
      },
    })
      .then((response: PostageInfo) => {
        this.postageInfo = response;
        this.postageInfo.transList.forEach((transItem) => {
          transItem.freeType = !!transItem.freeType;
        });
        this.isDisabled = !response.operAuthority;
        this.getProvinceList(loading);
      })
      .catch((error) => {
        loading.close();
      });
  }

  /**
   * 增加派送地区
   */
  public addArea() {
    SelectProvince.open({ outProvinceIds: this.getAreaId, selectedProvinceIds: [] })
      .then((areaIdList) => {
        const result = {
          transDetailId: 0,
          areaList: areaIdList,
          shippingPrice: 0,
          freeType: '',
          typeVal: 0,
          freeShipping: false,
        };
        this.postageInfo.transList.push(result);
      })
      .catch((error) => {
        // 勿删 否则有未知BUG QAQ
        this.postageInfo.transList = this.postageInfo.transList.concat([]);
      });
  }

  /**
   * 选择网点
   */
  public onSelecteSite() {
    new NewSelectSite().open({
      service: 'transport',
      selectCodes: this.postageInfo.siteCodeList,
      param: { transId: this.postageInfo.transId },
      readonly: this.isDisabled,
    }).then((res) => {
      this.postageInfo.siteCodeList = res;
    }, noop);
  }

  /**
   * 获取区域列表
   */
  public getProvinceList(loading) {
    IPSService.getProvinceList({
      postParams: {
        outProvinceIds: [],
      },
    })
      .then((response) => {
        response.list.forEach((item) => {
          this.areaList = this.areaList.concat(item.areaList);
        });
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 根据区域ID获取区域名称 用于回显
   */
  public getAreaName(areaIds: Array<number>) {
    const result = [];
    this.areaList.forEach((areaItem) => {
      if (areaIds.includes(areaItem.areaId)) {
        result.push(areaItem.areaName);
      }
    });
    return result.join(',');
  }

  /**
   * 删除策略
   */
  public deleteTrans(index) {
    this.$confirm('确定删除该策略?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((response) => {
      if (response == 'confirm') {
        this.postageInfo.transList.splice(index, 1);
      }
    });
  }

  /**
   * 编辑策略
   */
  public editTrans(index: number) {
    const result = this.postageInfo.transList[index].areaList;
    result.forEach((item) => {
      if (this.getAreaId.includes(item)) {
        this.getAreaId.splice(this.getAreaId.indexOf(item), 1);
      }
    });
    SelectProvince.open({ outProvinceIds: this.getAreaId, selectedProvinceIds: result })
      .then((areaIdList) => {
        this.postageInfo.transList[index].areaList = areaIdList;
      })
      .catch((error) => {
        // 勿删 否则有未知BUG QAQ
        this.postageInfo.transList = this.postageInfo.transList.concat([]);
      });
  }

  /**
   * 保存
   */
  public onSave() {
    this.$refs.form.validate((result) => {
      if (result) {
        if (!this.postageInfo.transList || !this.postageInfo.transList.length) {
          this.$message.warning('请添加派送地区');
          return false;
        }
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });
        this.postageInfo.transList.forEach((transItem) => {
          transItem.freeType = Number(transItem.freeType);
        });
        IPSService.editPostage({
          postParams: {
            transId: this.postageInfo.transId,
            transName: this.postageInfo.transName,
            siteCodeList: this.postageInfo.siteCodeList,
            transList: this.postageInfo.transList,
          },
        })
          .then((response) => {
            if (response.ret || response.result) {
              this.$message.success('保存成功');
              this.$router.go(-1);
            }
            loading.close();
          })
          .catch(() => {
            loading.close();
          });
      }
    });
  }

  /**
   * 取消
   */
  public onCancle() {
    this.$router.go(-1);
  }

  /**
   * 指定条件改变
   */
  public onChange(val, item, index) {
    this.postageInfo.transList.splice(index, 1, item);
    this.postageInfo.transList[index].freeShipping = val;
    if (!val) {
      this.postageInfo.transList[index].freeType = '';
      this.postageInfo.transList[index].typeVal = 0;
    }
  }
}
